import { SVGProps } from 'react'
const BlendsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={19}
      fill={props.fill}
      {...props}
    >
      <path
        fill={props?.fill || '#fff'}
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.59 5.435c0 1.823 1.801 3.302 1.801 3.302s1.801-1.479 1.801-3.302c0-1.824-1.8-3.303-1.8-3.303S4.59 3.61 4.59 5.435Z"
      />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.109 7.628c1.485 1.486 1.28 4.099 1.28 4.099s-2.612.203-4.098-1.281C.804 8.962 1.01 6.347 1.01 6.347s2.612-.205 4.099 1.28Z"
      />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.673 7.628c-1.486 1.486-1.28 4.099-1.28 4.099s2.612.203 4.098-1.281c1.486-1.484 1.281-4.099 1.281-4.099s-2.612-.205-4.099 1.28ZM5.109 13.031c1.485 1.486 1.28 4.1 1.28 4.1s-2.612.202-4.098-1.282C.804 14.365 1.01 11.75 1.01 11.75s2.612-.205 4.099 1.281Z"
      />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7.673 13.031c-1.486 1.486-1.28 4.1-1.28 4.1s2.612.202 4.098-1.282c1.486-1.484 1.281-4.099 1.281-4.099s-2.612-.205-4.099 1.281ZM6.39 17.13v1.201"
      />
      <path fill={props?.fill || '#fff'} d="M11.773 6.342v-1.4 1.4Z" />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.773 6.342v-1.4"
      />
      <path fill={props?.fill || '#fff'} d="M11.773 12.342v-1.4 1.4Z" />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.773 12.342v-1.4"
      />
      <path fill={props?.fill || '#fff'} d="M1 6.4V5v1.4Z" />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 6.4V5"
      />
      <path fill={props?.fill || '#fff'} d="M1 12.4V11v1.4Z" />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 12.4V11"
      />
      <path fill={props?.fill || '#fff'} d="M6.39 2.331v-1 1Z" />
      <path
        stroke={props?.fill || '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.39 2.331v-1"
      />
    </svg>
  )
}
export default BlendsIcon
